import { useMemo } from "react";
import {
  InternalAdminTagListInput,
  InternalAdminTagListQuery,
  InternalAdminTagListQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_TAG_LIST_QUERY from "../_networking/internal-admin-tag-list";

interface IProps {
  organizationId?: string;
  input: InternalAdminTagListInput;
}

const useInternalAdminTagList = ({ organizationId, input }: IProps) => {
  const { data, loading, refetch } = useQuery<
    InternalAdminTagListQuery,
    InternalAdminTagListQueryVariables
  >(INTERNAL_ADMIN_TAG_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: organizationId
      ? {
          organizationId,
          input,
        }
      : undefined,
    skip: !organizationId,
  });

  const tags = useMemo(() => {
    if (!data) return [];
    return [...data.internalAdminTagList];
  }, [data]);

  return {
    tags,
    loading,
    refetch,
  };
};

export default useInternalAdminTagList;
